<div #threadContainer class="thread">
  <div
    *ngFor="let message of messages; trackBy: trackByMessage"
    class="message"
    [class.user]="message.role === 'user'"
    [class.assistant]="message.role !== 'user'"
  >
    <div class="avatar">
      <mat-icon fontIcon="{{ message.role === 'user' ? 'person' : 'smart_toy' }}"></mat-icon>
    </div>
    <div class="message-main">
      <div class="bubble">
        <div class="content markdown-body" [innerHTML]="message.content | markdown"></div>
      </div>

      <div class="interactive-sections" *ngIf="message.role === 'assistant' && getInteractiveSections(message).length > 0">
        <div class="interactive-section" *ngFor="let section of getInteractiveSections(message)">
          <div class="interactive-label">{{ section.label }}</div>
          <button
            *ngFor="let item of section.items; index as itemIndex"
            type="button"
            class="interactive-option-btn"
            (click)="selectInteractiveOption(section.type, item)"
            [disabled]="isSending"
          >
            <span class="option-index">{{ itemIndex + 1 }}.</span>
            <span class="option-text">{{ item }}</span>
          </button>
        </div>
      </div>

      <div class="response-actions" *ngIf="message.role === 'assistant'">
        <button
          type="button"
          class="response-action-btn"
          (click)="copyResponse(message)"
          [matTooltip]="copiedMessageId === message.id ? 'Copied' : 'Copy response'"
          matTooltipPosition="above"
          [matTooltipShowDelay]="300"
          [attr.aria-label]="copiedMessageId === message.id ? 'Response copied' : 'Copy response'"
        >
          <mat-icon fontSet="material-icons-outlined">{{ copiedMessageId === message.id ? 'check' : 'content_copy' }}</mat-icon>
        </button>

        <button
          type="button"
          class="response-action-btn"
          [class.is-selected]="getFeedback(message) === 'good'"
          (click)="setFeedback(message, 'good')"
          matTooltip="Good response"
          matTooltipPosition="above"
          [matTooltipShowDelay]="300"
          aria-label="Good response"
        >
          <mat-icon fontSet="material-icons-outlined">thumb_up</mat-icon>
        </button>

        <button
          type="button"
          class="response-action-btn"
          [class.is-selected]="getFeedback(message) === 'bad'"
          (click)="setFeedback(message, 'bad')"
          matTooltip="Bad response"
          matTooltipPosition="above"
          [matTooltipShowDelay]="300"
          aria-label="Bad response"
        >
          <mat-icon fontSet="material-icons-outlined">thumb_down</mat-icon>
        </button>

        <button
          type="button"
          class="response-action-btn"
          (click)="retryResponse(message)"
          [disabled]="isSending"
          matTooltip="Try again"
          matTooltipPosition="above"
          [matTooltipShowDelay]="300"
          aria-label="Try again"
        >
          <mat-icon fontSet="material-icons-outlined">autorenew</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="typing" *ngIf="isSending">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <span>Thinking...</span>
  </div>

</div>

<div class="error-banner" *ngIf="error" [ngClass]="'error-' + error.kind">
  <div class="error-kind">{{ errorLabel }}</div>
  <div class="message-text">{{ error.message }}</div>
  <button mat-button color="warn" (click)="clearError.emit()">Dismiss</button>
</div>
